import axios from 'axios';
import hyperid from 'hyperid';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { StepperNav } from 'vertical-stepper-nav';

const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;

export const CrisisTeam = (props) => {
  const instance = hyperid();
  const parsedQueryString = queryString.parse(window.location.search);
  const employeeId = parseInt(parsedQueryString.employeeId, 10);
  const [session, setSession] = useState();
  const [employee, setEmployee] = useState();
  const [reports, setReports] = useState();
  const [filteredReports, setFilteredReports] = useState();
  const [listView, setListView] = useState(true);
  const [site, setSite] = useState();
  const [steps, setSteps] = useState([]);

  async function initSession() {
    const id = instance.uuid;
    await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
      email: `${id}@my-lobby.com`,
      password: `${id}@my-lobby.com`,
      siteId: employee.sites[0],
    });

    try {
      const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
        email: `${id}@my-lobby.com`,
        password: `${id}@my-lobby.com`,
        siteId: employee.sites[0],
      });

      setSession(login.data);
    } catch (error) {
      return {
        error: error.response.data.error,
      };
    }
  }

  useEffect(() => {
    props.hideLoader();
  }, [props]);

  useEffect(() => {
    if (employee) {
      initSession();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employee]);

  const getTimeAMPMFormat = (timeStamp) => {
    const date = new Date(timeStamp);
    let hours = date.getHours();
    let minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    return hours + ':' + minutes + ' ' + ampm;
  };

  useEffect(() => {
    if (employeeId) {
      axios
        .get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/employees/${employeeId}`)
        .then((res) => {
          setEmployee(res.data.employee);
          axios
            .get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/emergency_reports/list?siteId=${res.data.employee.sites[0]}`)
            .then((resR) => {
              const reports = resR.data.emergencyReports.filter((r) => r.crisisOver === undefined);
              for (let i = 0; i < reports.length; i++) {
                reports[i].open = false;
              }
              const currentDate = new Date();
              currentDate.setHours(0, 0, 0, 0);

              const filtered = reports.filter(
                (item) =>
                  (item.rolcallStartedDate !== undefined && new Date(item.rolcallStartedDate) >= currentDate) ||
                  (item.rollcallSortedDate !== undefined && new Date(item.rollcallSortedDate) >= currentDate) ||
                  (item.rollcallSendReportDate !== undefined && new Date(item.rollcallSendReportDate) >= currentDate),
              );
              setReports(filtered);
              setFilteredReports(filtered);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (session) {
      axios
        .get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${employee.sites[0]}`, {
          headers: {
            Authorization: session.id,
          },
        })
        .then((s) => {
          setSite(s.data.site);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  useEffect(() => {
    if (filteredReports?.length && site) {
      const stepStart = [];
      stepStart.push({
        stepContent: (
          <div className="columns-1 self-start mb-2">
            <div className="w-full flex flex-row justify-start text-black">{getTimeAMPMFormat(site?.emergencyLog[site?.emergencyLog.length - 1].date)}</div>
            <div className="w-full flex flex-row justify-start text-black">
              {site?.emergencyLog[site?.emergencyLog.length - 1].description.label} - <span className="text-black font-bold"> {site?.name}</span>
            </div>
          </div>
        ),
        stepStatusCircleSize: 16,
        stepStateColor: 'green',
      });
      for (var i = 0; i < filteredReports.length; i++) {
        if (filteredReports[i]?.rolcallStartedDate) {
          stepStart.push({
            stepContent: (
              <div key={`${filteredReports[i]?.id} + rollcallstart`} className="columns-1 self-start mb-2">
                <div className="w-full flex flex-row justify-start text-black">{getTimeAMPMFormat(filteredReports[i]?.rolcallStartedDate)}</div>
                <div className="w-full flex flex-row justify-start text-black">
                  {' '}
                  Fire Warden {i + 1}# <span className="text-black font-bold"> {filteredReports[i]?.name} started his roll call</span>
                </div>
              </div>
            ),
            stepStatusCircleSize: 16,
            stepStateColor: 'pink',
          });
        }
        if (filteredReports[i]?.rollcallSortedDate) {
          stepStart.push({
            stepContent: (
              <div key={`${filteredReports[i]?.id} + rollcallsorted`} className="columns-1 self-start mb-2">
                <div className="w-full flex flex-row justify-start text-black">{getTimeAMPMFormat(filteredReports[i]?.rollcallSortedDate)}</div>
                <div className="w-full flex flex-row justify-start text-black">
                  {' '}
                  Fire Warden {i + 1}# <span className="text-black font-bold"> {filteredReports[i]?.name} sorted his roll call</span>
                </div>
              </div>
            ),
            stepStatusCircleSize: 16,
            stepStateColor: 'pink',
          });
        }
        if (filteredReports[i]?.rollcallSendReportDate) {
          stepStart.push({
            stepContent: (
              <div key={`${filteredReports[i]?.id} + rollcallsend`} className="columns-1 self-start mb-2">
                <div className="w-full flex flex-row justify-start text-black">{getTimeAMPMFormat(filteredReports[i]?.rollcallSendReportDate)}</div>
                <div className="w-full flex flex-row justify-start text-black">
                  {' '}
                  Fire Warden {i + 1}# <span className="text-black font-bold"> {filteredReports[i]?.name} send his roll call</span>
                </div>
              </div>
            ),
            stepStatusCircleSize: 16,
            stepStateColor: 'pink',
          });
        }
      }
      setSteps(stepStart);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [site]);

  useEffect(() => {
    if (steps) {
      console.log('====================================');
      console.log('steps --->', steps);
      console.log('====================================');
    }
  }, [steps]);

  const filterReports = (query) => {
    if (query) {
      let filtered = [];
      reports.forEach((item) => {
        if (item.warden?.toLowerCase().includes(query.toLowerCase())) {
          filtered.push(item);
        } else {
          if (item.missingPeople.length > 0) {
            item.missingPeople.forEach((mp) => {
              if (mp.name.toLowerCase().includes(query.toLowerCase())) {
                filtered.push(item);
              }
            });
          }
        }
      });
      setFilteredReports(filtered);
    } else {
      setFilteredReports(reports);
    }
  };

  return (
    <div className="container max-w-sm mx-auto bg-white-200 pt-6">
      <div className="grid grid-cols-1">
        <div className="flex justify-center grid-cols-2">
          <span className="text-black font-bold font-medium col-1 mr-1">Crisis Team Lead:</span>
          <span className="text-black col-1">{employee?.name}</span>
        </div>
        <div className="flex justify-center grid-cols-2 mt-4">
          <span className="text-black font-bold font-medium col-1 mr-1">Office Location:</span>
          <span className="text-black col-1">{employee?.musterLocation}</span>
        </div>
        <div className="flex justify-center grid-cols-1 mt-4">
          <span className="text-black font-bold text-xl col-1">Summary - Not Present</span>
        </div>
        <div className="flex justify-center grid-cols-4 mt-4">
          <span className="text-black font-bold font-medium col-1 mr-1">Date:</span>
          <span className="text-black col-1">{new Date().toDateString().split(' ').slice(1).join(' ')}</span>
          <span className="text-black col-1 mx-2">|</span>
          <span className="text-black col-1">{new Date().toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
        </div>
        {listView ? (
          <div className="flex justify-center grid-cols-1 mt-4">
            <input
              className="placeholder:text-slate-800 text-black w-9/12 block bg-gray-300 text-center border border-slate-300 rounded-full py-2 pl-9 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm"
              placeholder="Find by name"
              type="text"
              name="search"
              onChange={(e) => filterReports(e.target.value)}
            />
          </div>
        ) : null}
        <div className="flex flex-row justify-center mt-5">
          <div
            className={`${listView ? 'text-blue-600' : 'text-black'} ${listView ? 'font-semibold' : 'font-medium'} flex flex-column mx-auto`}
            onClick={() => setListView(true)}
          >
            List View
          </div>
          <div
            className={`${!listView ? 'text-blue-600' : 'text-black'} ${!listView ? 'font-semibold' : 'font-medium'} flex flex-column mx-auto`}
            onClick={() => setListView(false)}
          >
            Timeline View
          </div>
        </div>
        {listView ? (
          <div
            className="divide-y"
            style={{ width: '100%', height: 800, overflow: 'scroll', paddingBottom: 50, display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 10 }}
          >
            {filteredReports?.map((fr, index) => {
              return (
                <div key={index} className="flex flex-row justify-center relative">
                  <div className="w-9/12 grid grid-cols-12 content-start my-3 " style={{ height: 'auto', minHeight: 150, overflow: 'scroll' }}>
                    <div className="text-black col-start-1 col-span-3">Warden:</div>
                    <div className="text-black col-start-4 col-span-5">{fr.name}</div>
                    <div className="text-black col-start-1 col-span-6">Total Emp Absent: </div>
                    <div className="text-black col-start-7 col-span-4">
                      {fr.absentEmployees}/{fr.totalEmployees}
                    </div>
                    <div className="text-black col-start-1 col-span-6">Missing People: </div>
                    <div
                      style={{
                        width: 250,
                        height: fr.open ? 'auto' : 0,
                        overflow: 'scroll',
                        display: 'flex',
                        flexDirection: 'column',
                        justifySelf: 'center',
                        marginTop: 30,
                        marginBottom: 50,
                      }}
                    >
                      {fr.open
                        ? fr.missingPeople?.map((mp, i) => {
                            return (
                              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: 100, marginBottom: 10 }} key={i}>
                                <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10 }}>
                                  <span className="text-blue-600 underline text-xl font-extralight">{mp.name}</span>
                                  <a href={`tel: ${mp.phone}`} className="text-black font-extralight text-xs">
                                    Phone: {mp.phone}
                                  </a>
                                  <span className="text-black font-extralight text-xs">Email: {mp.email}</span>
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                  {mp?.id !== undefined ? (
                                    <img
                                      src={`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitors/getAvatar/${mp.id}?small=true&access_token=${session.id}`}
                                      alt="visitor img"
                                      style={{ width: 50, height: 50, marginTop: 10 }}
                                    />
                                  ) : null}
                                </div>
                              </div>
                            );
                          })
                        : null}
                    </div>
                  </div>
                  <div
                    className="absolute bottom-0 w-52 h-11 pb-3"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifySelf: 'center',
                    }}
                  >
                    <button
                      onClick={() => {
                        const filteredReportsNew = filteredReports.map((f) => {
                          const newF = { ...f };
                          if (newF.id === fr.id) {
                            newF.open = !newF.open;
                          }
                          return newF;
                        });
                        setFilteredReports(filteredReportsNew);
                      }}
                      className="text-white bg-blue-400 hover:bg-blue-500 text-lg font-medium border-black-900 py-2 px-4 rounded-full"
                    >
                      {fr.open === false ? 'Open List' : 'Collapse'}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="w-full columns-1 self-center mb-10">
            <div className="w-full mt-5 flex flex-row justify-center">
              <span className="text-black font-bold">Emergency Timeline</span>
            </div>
            <div className="w-full mt-3 flex flex-row justify-center">
              <StepperNav
                steps={steps.map((s) => {
                  return {
                    stepContent: () => s.stepContent,
                    stepStatusCircleSize: s.stepStatusCircleSize,
                    stepStateColor: s.stepStateColor,
                  };
                })}
              />
            </div>
          </div>
        )}
        <div
          className="text-2xl text-center max-w-sm mx-auto"
          style={{
            position: 'fixed',
            bottom: 0,
            width: '100%',
            background: '#272223',
            height: 43,
          }}
        >
          <footer>
            <p>Powered by My-Lobby.com</p>
          </footer>
        </div>
      </div>
    </div>
  );
};
